onReady(($) => {
    //sidebar add x close
    $(".glossallout")
        .on('click', () => {
            $("#search-highlight")
                .addClass('fadedsearch');
            $("#search-highlights")
                .removeClass('fadedsearch');
            $("#ad-fraud-detection")
                .removeClass('active');
            $("#marketing-intelligence")
                .removeClass('active');
            $("#partner-marketing")
                .removeClass('active');
        });

    $(".glossallin")
        .on('click', () => {
            $("#search-highlight")
                .removeClass('fadedsearch');
            $("#search-highlights")
                .addClass('fadedsearch');
            $("#ad-fraud-detection")
                .removeClass('active');
            $("#marketing-intelligence")
                .removeClass('active');
            $("#partner-marketing")
                .removeClass('active');
        });

    $("#partner-marketing, #marketing-intelligence, #ad-fraud-detection")
        .on('click', () => $(".nav-pills > li")
            .removeClass('active'));

    $('#search-highlight, #search-highlights')
        .hideseek({highlight: true});

    $('.page-template-page-gloassary [data-toggle="tab"]')
        .on('click', function (event) {
            event.preventDefault()
            const clickedPill = $(this);
            if ($(this)
                .hasClass('active')) {
                return;
            }

            const tabPaneId = clickedPill[0].href.split('#')
                .pop()
            $('.nav > li.active, .tab-pane.active')
                .removeClass('active')
            clickedPill.parent('li')
                .addClass('active')
            $(`#${tabPaneId}`)
                .addClass('active')
        })

});
